"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapsible = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var Collapsible = function (_a) {
    var animate = _a.animate, children = _a.children, className = _a.className, _b = _a.el, CollapsibleElement = _b === void 0 ? 'div' : _b, _c = _a.easing, easing = _c === void 0 ? tokens_1.default.easingStandard : _c, _d = _a.open, open = _d === void 0 ? false : _d, props = __rest(_a, ["animate", "children", "className", "el", "easing", "open"]);
    var CollapsibleClasses = classnames_1.default('Collapsible', className, {
        'Collapsible--hidden': !open,
        'Collapsible--animated': animate,
    });
    var animateHeightProps = {
        animateOpacity: true,
        duration: parseInt(tokens_1.default.durationSlow, 10),
        easing: easing,
        height: open ? 'auto' : 0,
    };
    return (react_1.default.createElement(CollapsibleElement, __assign({ className: CollapsibleClasses }, props), animate ? (react_1.default.createElement(react_animate_height_1.default, __assign({}, animateHeightProps), children)) : (children)));
};
exports.Collapsible = Collapsible;
//# sourceMappingURL=Collapsible.js.map